// Components
import { useState, useCallback } from "react"
import { useDispatch } from "react-redux"
import { VFieldContainer } from "@components/common"
// Styles
// Libs
import { t } from "i18next"
import { debounce, uniqBy } from "lodash"
import { getAddresses } from "@slices/addresses"

const InputAddress = ({ width = "auto", handleChange }) => {
  const [addressList, setAddressList] = useState([])
  const dispatch = useDispatch()

  const searchAddress = async (value) => {
    if (!value) {
      setAddressList([])
      return
    }

    try {
      const { results } = await dispatch(getAddresses(value)).unwrap()
      const formattedResults =
        uniqBy(results, "fullAddress")?.map((item, key) => ({
          ...item,
          id: key
        })) || []
      console.log({ value, results, formattedResults })

      setAddressList(formattedResults)
    } catch (error) {
      console.error("搜尋地址時發生錯誤:", error)
      setAddressList([])
    }
  }

  const dispatchGetAddress = useCallback(
    debounce((event, value) => {
      searchAddress(value)
    }, 1000),
    [dispatch, searchAddress]
  )

  return (
    <VFieldContainer
      index={0}
      width={width}
      id="autoCompleteAddress"
      label={t("TEXT_COMMON_address_search")}
      type="autocomplete"
      list={addressList}
      placeholder={t("TEXT_COMMON_address_placeholder")}
      noOptionsText={t("TEXT_COMMON_address_no_results")}
      getOptionLabel={(option) => option.fullAddress || ""}
      filterOptions={(options) => options}
      disableClearable
      onChange={(event, value) => {
        handleChange(value)
      }}
      onInputChange={dispatchGetAddress}
    />
  )
}

export default InputAddress
